import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;

@Injectable()
export class ProductSelectionService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }

  handleError = (error) => {
    return throwError(error);
  }

  getInitialDetails() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('SERVICE-AUTH-TOKEN', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.get(this.utilityService.getEnvConfig().initialUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  createPageLoadProperties(url: string, title: string, friendlyPageName: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.post(dataurl, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => resp.body)
      ,catchError( this.handleError ));
  }

  signupDetails1(emmProductCode, selectedProductId) {
    const kmeResellerId = this.utilityService.getEnvConfig().kmeResellerId;
    let finalResp;
    let data = {
      'resellerId': kmeResellerId,
      'ids': [
        selectedProductId
      ]
    };
    if (emmProductCode === 'DMPSKME') {
      finalResp = this.utilityService.getEnvConfig().getSamsungId, data;
    }
    return this.httpClientService.post(finalResp, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => { // console.log(res+ ' --------- validation');
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  signupDetails(emmProductCode, selectedProductId) {
    let finalResp, MdmUrl;
    const kmeResellerId = this.utilityService.getEnvConfig().kmeResellerId;
    const data = {
      'resellerId': kmeResellerId,
      'ids': [
        selectedProductId
      ]
    };
    return this.httpClientService.post(this.utilityService.getEnvConfig().getSamsungId, data, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => { // console.log(res+ ' --------- validation');
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  mdmDetails() {
    return this.httpClientService.get(this.utilityService.getEnvConfig().mdmDetails, this.getHeaders())
      .pipe(
       map((res: HttpResponse<any>) => {
        if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }

  samsungValidate() {
    let samsungKmeId;
    let kmeResellerId = this.utilityService.getEnvConfig().kmeResellerId;
    samsungKmeId = sessionStorage.getItem('selectedAccID');
    const data = {
      'resellerId': kmeResellerId,
      'ids': [
        samsungKmeId
      ]
    };
    
    return this.httpClientService.post(this.utilityService.getEnvConfig().samsungValidate, data, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => { // console.log(resp);
        return resp.body;
      }
      )
      ,catchError( this.handleError ));
  }

  orgIdValidation(orgid) {
    const data = {
      'orgId': orgid
    };
    return this.httpClientService.post(this.utilityService.getEnvConfig().appleOrgValidate, data, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => { // console.log(resp);
        return resp.body;
      }),
      catchError( this.handleError ));
  }

  zteIdValidation(zteid, agreementID) {
    const data = {
      "zteId": zteid,
      "agreementId": agreementID
    };
    return this.httpClientService.post(this.utilityService.getEnvConfig().zteIdValidate, data, this.getHeaders())
      .pipe(
       map((resp: HttpResponse<any>) => { // console.log(resp);
        return resp.body;
      }),
      catchError( this.handleError ));
  }

  setProdCode(code) {
    if (code === 'KME') {
      sessionStorage.setItem('prodcode', 'Samsung Knox Mobile Enrollment (KME)');
    }
    else if (code === 'ZTP') {
      sessionStorage.setItem('prodcode', 'Android Zero-touch');
    }
    else if (code === 'ABM') {
      sessionStorage.setItem('prodcode', 'Apple Business Manager');
    }
  }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }
  
  getFanStatusSummary() {
    // will be calling actual api with company id;
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().getFanStatusSummarymock[0];
    } else {
      url = this.utilityService.getEnvConfig().dashboardSummary;
    }

    return this.httpClientService.get(url, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      })
      ,catchError( this.handleError ));
  }

  getInquireProfile(fan: any) {
    let url = this.utilityService.getEnvConfig().getInquireProfile + "?fan="+ fan;
    return this.httpClientService.get(url, this.getHeaders())
      .pipe(
        map((resp: HttpResponse<any>) => { // console.log(resp);
          return resp.body;
        })
      ,catchError( this.handleError ));
  }

  tranIdValidation(tranid, isMock) {
    if(isMock){
        return this.httpClientService.get('restservices/cms/v1/UseCase/check_transaction_mock', this.get_headers())
      .pipe(
        map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
    }else{
      const data = {
        'deviceEnrollmentTransactionId': tranid
      };
      return this.httpClientService.post(this.utilityService.getEnvConfig().tranIdValidate, data, this.getHeaders())
        .pipe(
         map((resp: HttpResponse<any>) => { // console.log(resp);
          return resp.body;
        }),
        catchError( this.handleError ));
    }
  }

  // getCheckTransactionMockDetails(){
  //   return this.httpClientService.get('restservices/cms/v1/UseCase/check_transaction_mock', this.get_headers())
  //   .pipe(
  //     map((test: HttpResponse<any>) => test.body)
  //    ,catchError( this.handleError ));
  // }

}
